module.exports = __webpack_public_path__ + "static/sample-2-df9ee5e0ba1fc01d9718688701672874.png";